






































































































































































































import { LoaderCircle, Scrollbar } from '@/app/components';
import { useFilters } from '@/app/composable';
import store from '@/app/store';
import { AccessLevel } from '@/modules/access-policy/constants/access-levels.constants';
import { useAsset } from '@/modules/asset/composable/asset';
import { useAssetExtentMetadata } from '@/modules/asset/composable/asset-extent-metadata';
import { Asset } from '@/modules/asset/types';
import { useAxios } from '@/app/composable';
import { ClipboardListIcon, CubeTransparentIcon, XIcon } from '@vue-hero-icons/solid';
import { PropType, computed, defineComponent, ref, watch } from '@vue/composition-api';
import { ContractsAPI } from '../../api';
import { useCart } from '../../composable';

export default defineComponent({
    name: 'AssetDetails',
    components: {
        LoaderCircle,
        Scrollbar,
        XIcon
    },
    props: {
        asset: {
            type: Object as PropType<Asset>,
            default: null,
        },
        showTabs: {
            type: Boolean,
            default: true,
        },
        activePendingContracts: {
            type: Array,
            default: () => [],
        },
    },
    setup(props, { root, emit }) {
        const assetDetailsTabs = [
            { key: 'overview', title: 'Overview', icon: ClipboardListIcon },
            { key: 'related', title: 'Related', icon: CubeTransparentIcon },
        ];

        const { exec, loading } = useAxios(true);

        const { formatLargeNumber, formatDate, capitalise } = useFilters();
        const { assetTypeClass, assetTypeName } = useAsset();

        const { cartAssetIds, addToCart, removeFromCart, cart, cartLimit } = useCart();

        const isBlockchainEnabled = computed(() => store.getters.sharing.isBlockchainEnabled);
        const user = computed(() => store.state.auth.user);
        const ethNetwork = computed(() => store.state.sharing.network);
        const hasWallet = computed(() => store.getters.organisation.hasWallet);
        const isAssetPublic = computed(() => props.asset && props.asset.accessLevel === AccessLevel.Public);
        const cartLimitReached = computed(() => cart.value.length >= cartLimit);

        const activePendingContract = computed(() => {
            if (props.asset) {
                const contract: any = props.activePendingContracts.find(
                    (item: any) => item.assetId === props.asset.id || item.barteringAssetId === props.asset.id,
                );
                return contract ?? null;
            }
            return null;
        });

        const belongsToUserOrOrganisation = computed(() => {
            if (props.asset && user.value) {
                if (user.value.organisationId && props.asset.organisation)
                    return user.value.organisationId === props.asset.organisation.id;
                return user.value.id === props.asset.createdBy.id;
            }
            return true;
        });

        const hasOrganisation = ref<boolean>(!!user.value.organisationId);
        const acquiringAsset = ref<boolean>(false);
        const temporalCoverage = ref<string | null>(null);

        const acquireAsset = (id: number) => {
            acquiringAsset.value = true;
            const payload = {
                isBundle: false,
                contracts: [{ fields: [], duration: { type: 'forever', number: null }, assetId: id }],
            };
            exec(ContractsAPI.create(payload))
                .then(() => {
                    props.activePendingContracts.push(id);
                    acquiringAsset.value = false;
                    (root as any).$toastr.s('Asset acquired!', 'Success');

                    emit('reload-active-pending');
                })
                .catch(() => {
                    acquiringAsset.value = false;
                    (root as any).$toastr.e('Asset acquisition failed.', 'Error');
                });
        };

        const buyAsset = (id: number) => {
            root.$router.push({ name: 'contract-details', params: { type: 'create', id: `${id}` } });
        };

        const viewedAsset = ref<any>(null);

        watch(
            () => props.asset,
            () => {
                viewedAsset.value = props.asset;
                const { temporalCoverage: tc } = useAssetExtentMetadata(viewedAsset);
                temporalCoverage.value = tc.value;
            },
        );

        const dataProvider = computed(() => {
            return props.asset.organisation
                ? props.asset.organisation.businessName
                : `${props.asset.createdBy.firstName} ${props.asset.createdBy.lastName}`;
        });

        return {
            formatDate,
            formatLargeNumber,
            buyAsset,
            acquireAsset,
            ethNetwork,
            hasWallet,
            belongsToUserOrOrganisation,
            hasOrganisation,
            isBlockchainEnabled,
            temporalCoverage,
            addToCart,
            removeFromCart,
            cartAssetIds,
            assetTypeClass,
            assetTypeName,
            acquiringAsset,
            assetDetailsTabs,
            loading,
            capitalise,
            isAssetPublic,
            activePendingContract,
            cartLimitReached,
            dataProvider
        };
    },
});
